import { Skeleton, Stack } from "@chakra-ui/react";

export const LoadingSkeleton = ({ num = 3, width= 900 }: { num?: number, width?: number }) => {
    return <Stack width={width}>
        {(Array.from({length: num})).map((_, index) => {
            return <Skeleton key={index} height='20px' />;
        })}
    </Stack>;
}